import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { makeStyles } from '@material-ui/core/styles';
import NextMenu from '@material-ui/core/Menu';
import NextMenuItem from '@material-ui/core/MenuItem';
import Typography from '@material-ui/core/Typography';

const useStyles = makeStyles(theme => ({
  menuPaper: {
    minWidth: 150,
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.common.white,
  },
}));

const MenuItem = React.forwardRef((props, ref) => {
  const { ...restProps } = props;
  return <NextMenuItem dense {...restProps} ref={ref} />;
});

const Menu = React.forwardRef((props, ref) => {
  const { items, onItemClick, ...restProps } = props;
  const classes = useStyles(props);
  const clickItem = (e, item) => {
    onItemClick && onItemClick(item);
    props.onClose();
  };
  return (
    <NextMenu {...restProps} classes={{ paper: classes.menuPaper }} ref={ref}>
      {items &&
        items.map(item => (
          <MenuItem key={item.label} onClick={e => clickItem(e, item)}>
            <Typography variant="subtitle1">{item.label}</Typography>
          </MenuItem>
        ))}
    </NextMenu>
  );
});

export default Menu;
